import { render, staticRenderFns } from "./TermsDefault.vue?vue&type=template&id=869911b0&scoped=true&"
import script from "./TermsDefault.vue?vue&type=script&lang=js&"
export * from "./TermsDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869911b0",
  null
  
)

export default component.exports